@if (showTooltip && tooltipText) {
  <div
    class="u-relative tooltip option__tooltip"
    role="tooltip"
    [attr.aria-label]="tooltipText"
    [attr.data-tooltip]="tooltipText"
  ></div>
}
@if (options.length > 0) {
  <ul class="form-control__menu" tabindex="-1" role="menu">
    @for (option of options; track option) {
      <accessible-option
        (mouseover)="determineTooltip(option)"
        (mouseout)="showTooltip = false"
        [option]="option"
        (selected)="select($event)"
      >
      </accessible-option>
    }
  </ul>
}
